<rask-fieldset-toggle
    label="Fritextsök"
    [formGroup]="form"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <rask-input
        label="Fritextsök"
        class="w-100"
        formControlName="fritext">
    </rask-input>
</rask-fieldset-toggle>